import {
  IPavementStructureScenarioImperial,
  IPavementStructureScenarioMetric
} from "@/modules/structure/interfaces/pavementStructure";
import {UnitSystem} from "@/interfaces/units";
import {IPerRoadLayerImperial} from "@/modules/perRoad/interfaces/perRoad";
import {
  perRoadLayerImperialToMetric,
  perRoadLayerMetricToImperial,
  perRoadSeasonImperialToMetric,
  perRoadSeasonMetricToImperial,
  perRoadTireLoadImperialToMetric,
  perRoadTireLoadMetricToImperial
} from "@/modules/perRoad/lib/unitConversion/perRoadConversion";
import convert from "convert-units";
import {ImperialUnits, MetricUnits} from "@/lib/unitConversion/unitConversionFactors";

export const structureScenarioImperialToMetric = (A: IPavementStructureScenarioImperial): IPavementStructureScenarioMetric => {

  return {
    ...A,
    axleLoad_kg: convert(A.axleLoad_lb).from(ImperialUnits.MASS_LB).to(MetricUnits.MASS_KG),
    loads: A.loads.map(load => perRoadTireLoadImperialToMetric(load)),
    unitSystem: UnitSystem.Metric,
    structureSeasons: A.structureSeasons.map((imperialSeason) => perRoadSeasonImperialToMetric(imperialSeason)),
    structureLayers: A.structureLayers.map((imperialLayer: IPerRoadLayerImperial) => perRoadLayerImperialToMetric(imperialLayer))
  };
};

export const structureScenarioMetricToImperial = (A: IPavementStructureScenarioMetric): IPavementStructureScenarioImperial => {

  return {
    ...A,
    axleLoad_lb: convert(A.axleLoad_kg).from(MetricUnits.MASS_KG).to(ImperialUnits.MASS_LB),
    loads: A.loads.map(load => perRoadTireLoadMetricToImperial(load)),
    unitSystem: UnitSystem.Imperial,
    structureSeasons: A.structureSeasons.map((metricSeason) => perRoadSeasonMetricToImperial(metricSeason)),
    structureLayers: A.structureLayers.map((metricLayer) => perRoadLayerMetricToImperial(metricLayer))
  };
};
